import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { MenuModule } from "primeng/menu";
import { ListboxModule } from "primeng/listbox";
import {TieredMenuModule} from 'primeng/tieredmenu';
import {PanelMenuModule} from 'primeng/panelmenu';
import {VirtualScrollerModule} from 'primeng/virtualscroller';
import {ScrollPanelModule} from 'primeng/scrollpanel';

import { AdministracionRoutingModule } from "./administracion-routing.module";
import { CatalogosComponent } from "./catalogos/catalogos.component";
import { ReportesComponent } from "./reportes/reportes.component";
import { ComponentesModule } from "../componentes/componentes.module";

@NgModule({
  declarations: [CatalogosComponent, ReportesComponent],
  imports: [
    CommonModule,
    AdministracionRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentesModule,
    PanelMenuModule,
    VirtualScrollerModule,
    ScrollPanelModule,

    MenuModule,
    ListboxModule,
  ],
})
export class AdministracionModule {}
